import React, { useState } from 'react';
import classNames from 'classnames';
import {
    useSsSelector as useSelector,
} from '~SpectateStore';
import { useTranslation } from 'react-i18next';
import { AnimatePresence, motion } from 'framer-motion';
import {
    ICONS_PATH,
    SUCCESS_ICON,
    SUCCESS_ICON_MRG,
} from './constants';
import { buildSpectateStaticAssetUrl } from '~spa/Utils/Spectate';
import { isMrgMarketingBrand } from '~spa/Utils/MarketingBrand';
import {
    selectBets,
    selectBetTotalStake,
    selectBetTotalReturns,
} from '~Betslip/selectors/betReceiptSelectors';
import formatCurrency from '~shared/utils/currencyUtils';

import BetsSection from '../../Full/Components/BetReceipt/BetsSection';
import CallToActions from '../../Full/Components/CallToActions';

import './styles.scss';

const BabyBetReceipt = () => {
    const [t] = useTranslation();
    const [collapsed, setCollapsed] = useState(true);

    const bets = useSelector(selectBets);
    const totalStake = useSelector(selectBetTotalStake);
    const potentialReturns = useSelector(selectBetTotalReturns);
    const hasAnySuccess = bets.some(bet => bet.success);
    const hasAnyFails = bets.some(bet => !bet.success);
    const hasAnyFreebet = bets.some(bet => bet.free_bet_id);

    const successFileName = isMrgMarketingBrand()
        ? SUCCESS_ICON_MRG
        : SUCCESS_ICON;
    const successIconUrl = buildSpectateStaticAssetUrl(`${ICONS_PATH}${successFileName}`);

    const placedClass = classNames('baby-receipt__placed', {
        'baby-receipt__placed-failed': hasAnyFails,
    });

    const messageClass = classNames('baby-receipt__placed-message', {
        'baby-receipt__placed-message-dropdown': hasAnySuccess,
        'baby-receipt__placed-message-failed': hasAnyFails,
        'baby-receipt__placed-message--flipped': !collapsed,
    });

    const contentClass = classNames('baby-receipt__content', {
        'baby-receipt__content-failed': hasAnyFails,
    });

    const gtmAttribute = `baby-bet-receipt;bet-success;${collapsed ? 'expand' : 'collapse'}`;

    const transitionBetPlaced = {
        type: 'spring',
        damping: 32,
        stiffness: 700,
    };
    const transitionBetsSection = {
        type: 'spring',
        damping: 60,
        stiffness: 980,
    };

    const variantsBetPlaced = {
        hidden: { y: '100%' },
        visible: { y: '0%' },
        exit: { y: '100%' },
    };
    const variantsBetsSection = {
        hidden: { height: 0 },
        visible: { height: 'fit-content' },
        exit: { height: 0 },
    };

    return (
        <>
            <div className="baby-receipt">
                <div className={placedClass}>
                    {
                        hasAnySuccess
                            ? <>
                                <object className="baby-receipt__placed--success" type="image/svg+xml" data={successIconUrl}></object>
                                <div className={contentClass}>
                                    <motion.div
                                        transition={transitionBetPlaced}
                                        variants={variantsBetPlaced}
                                        initial="hidden"
                                        animate="visible"
                                        exit="exit"
                                    >
                                        <div
                                            className={messageClass}
                                            onClick={() => setCollapsed(!collapsed)}
                                            data-spectate-product={gtmAttribute}
                                        >
                                            {t('betslip.bet_placed_success')}
                                        </div>
                                        <div>
                                            <div className='baby-receipt__total-stake'>
                                                <span>{t('betslip.total_stake')}</span>
                                                <span className='baby-receipt__total-stake-val'>
                                                    {
                                                        hasAnyFreebet
                                                            ? <span className='baby-receipt__total-stake-freebet'></span>
                                                            : null
                                                    }
                                                    {' '}
                                                    {formatCurrency(totalStake)}
                                                </span>
                                            </div>
                                            <div className='baby-receipt__total-returns'>
                                                <span>{t('betslip.potential_returns')}</span>
                                                <span className='baby-receipt__total-stake-val'>
                                                    {formatCurrency(potentialReturns)}
                                                </span>
                                            </div>
                                        </div>
                                    </motion.div>
                                </div>
                            </>
                            : <div className={contentClass}>
                                <div className={messageClass}>
                                    {t('betslip.bet_placed_fail')}
                                </div>
                            </div>
                    }
                </div>

                <AnimatePresence>
                {
                    (!collapsed || hasAnyFails)
                    && <motion.div
                        transition={transitionBetsSection}
                        variants={variantsBetsSection}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                        className="baby-receipt__bets-section"
                    >
                        <BetsSection bets={bets} />
                    </motion.div>
                }
                </AnimatePresence>
                <CallToActions />
            </div>
        </>
    );
};

export default BabyBetReceipt;
